import script from "./customImageBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./customImageBackground.vue?vue&type=script&setup=true&lang=js"

import "./customImageBackground.vue?vue&type=style&index=0&id=031cc94e&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031cc94e"]])

export default __exports__